import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class ClassModel extends Model 
{
	@attr name;
	@attr gender;

	@belongsTo('event', {inverse: 'classes', async: true}) EventId;
	@belongsTo('class-group', {inverse: 'classes', async: true}) ClassGroupId;
	@hasMany('entry', {inverse: 'ClassId', async: true}) entries;
	
	get displayName()
	{
		if(this.name != undefined)
			return this.name.split('*')[0];
		return "";
	}
}